import React from 'react'

import clsx from 'clsx'

interface RadioButtonProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  name?: string
  inputSize?: 'small' | 'medium' | 'large'
  variant?: 'primary' | 'secondary'
  disabled?: boolean
}

export const RadioButton = ({
  inputSize = 'medium',
  variant = 'primary',
  label,
  name,
  disabled = false,
  ...props
}: RadioButtonProps) => {
  const baseInputClasses = 'form-radio  focus:ring-2 focus:ring-offset-2'
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-5 h-5',
    large: 'w-6 h-6',
  }[inputSize]

  const textClasses = {
    small: 'text-xs text-gray-600',
    medium: 'text-sm text-gray-800',
    large: 'text-base text-gray-900',
  }[inputSize]

  const variantClasses = {
    primary: 'text-[#18343B] border-[#18343B] focus:ring-[#74BCCE] checked:border-[#18343B]',
    secondary: 'text-[#C44322] border-[#C44322] focus:ring-[#E0C0B8] checked:border-[#C44322]',
  }[variant]

  return (
    <label className={clsx('flex items-center space-x-2', disabled && 'cursor-not-allowed opacity-50')}>
      <input
        type="radio"
        name={name}
        className={clsx(baseInputClasses, sizeClasses, variantClasses, disabled && 'bg-gray-300')}
        disabled={disabled}
        {...props}
      />
      {label && <span className={clsx(textClasses)}>{label}</span>}
    </label>
  )
}
